import { render, staticRenderFns } from "./employment-form-form.vue?vue&type=template&id=4edad753&scoped=true&"
import script from "./employment-form-form.vue?vue&type=script&lang=js&"
export * from "./employment-form-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edad753",
  null
  
)

export default component.exports